export const welcomeStep: Record<
  number,
  {
    title:
      | 'welcome_title'
      | 'dashboards_title'
      | 'filters_title'
      | 'tabs_title'
      | 'widgets_title'
      | 'charts_title'
      | 'templates_title'
    body:
      | 'welcome_body'
      | 'dashboards_body'
      | 'filters_body'
      | 'tabs_body'
      | 'widgets_body'
      | 'charts_body'
      | 'templates_body'
    hint:
      | 'welcome_hint'
      | 'dashboards_hint'
      | 'filters_hint'
      | 'tabs_hint'
      | 'widgets_hint'
      | 'charts_hint'
      | 'templates_hint'
    src: string
  }
> = {
  // welcome
  [0]: {
    title: 'welcome_title',
    body: 'welcome_body',
    hint: 'welcome_hint',
    src: '/assets/media/welcome/welcome.png'
  },
  // dashboards
  [1]: {
    title: 'dashboards_title',
    body: 'dashboards_body',
    hint: 'dashboards_hint',
    src: '/assets/media/welcome/dashboards.png'
  },
  // tabs
  [2]: {
    title: 'tabs_title',
    body: 'tabs_body',
    hint: 'tabs_hint',
    src: '/assets/media/welcome/tabs.png'
  },
  // filters
  [3]: {
    title: 'filters_title',
    body: 'filters_body',
    hint: 'filters_hint',
    src: '/assets/media/welcome/filters.png'
  },
  // widgets
  [4]: {
    title: 'widgets_title',
    body: 'widgets_body',
    hint: 'widgets_hint',
    src: '/assets/media/welcome/widgets.png'
  },
  // charts
  [5]: {
    title: 'charts_title',
    body: 'charts_body',
    hint: 'charts_hint',
    src: '/assets/media/welcome/charts.png'
  },
  // catalog
  [6]: {
    title: 'templates_title',
    body: 'templates_body',
    hint: 'templates_hint',
    src: '/assets/media/welcome/catalog.png'
  }
}
